<template>
  <div class="invoiceDetail">
    <van-nav-bar
      title="申请开票"
      left-text=""
      left-arrow
      class="main-nav"
      fixed
      @click-left="onClickLeft"
    />
    <div
      class="invoiceDetail_content"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <p class="invoiceDetail_content_title">发票详情</p>
      <div class="invoiceDetail_content_top">
        <div class="invoiceDetail_content_top_left">电子发票：</div>
        <div
          class="invoiceDetail_content_top_righ"
          :style="{
            color:
              invoiceDetail.invoiceDetail == 0
                ? '#00AADF'
                : invoiceDetail.invoiceDetail == 2
                ? '#949C9D'
                : '#EE3721',
          }"
        >
          {{
            invoiceDetail.state == 0
              ? "开票中..."
              : invoiceDetail.state == 1
              ? "已取消"
              : invoiceDetail.state == 2
              ? "开票成功"
              : "已注销"
          }}
        </div>
      </div>
      <div class="invoiceDetail_content_cen">
        <div class="invoiceDetail_content_cen_content">
          <div class="invoiceDetail_content_cen_content_left">*抬头类型：</div>
          <div
            class="invoiceDetail_content_cen_content_righ invoiceDetail_content_cen_content_righBold"
          >
            {{ invoiceDetail.type == 2 ? "个人" : "企业单位" }}
          </div>
        </div>
        <div
          class="invoiceDetail_content_cen_content"
          v-if="invoiceDetail.type == 1"
        >
          <div class="invoiceDetail_content_cen_content_left">发票抬头：</div>
          <div class="invoiceDetail_content_cen_content_righ">
            {{ invoiceDetail.title }}
          </div>
        </div>
        <div
          class="invoiceDetail_content_cen_content"
          v-if="invoiceDetail.type == 1"
        >
          <div class="invoiceDetail_content_cen_content_left">公司税号：</div>
          <div class="invoiceDetail_content_cen_content_righ">
            {{ invoiceDetail.taxNo }}
          </div>
        </div>
        <div class="invoiceDetail_content_cen_content">
          <div class="invoiceDetail_content_cen_content_left">发票内容：</div>
          <div class="invoiceDetail_content_cen_content_righ">
            {{ invoiceDetail.content }}
          </div>
        </div>
        <div class="invoiceDetail_content_cen_content">
          <div class="invoiceDetail_content_cen_content_left">开票金额：</div>
          <div class="invoiceDetail_content_cen_content_righ">
            <span>{{ invoiceDetail.amount }}</span
            >元
          </div>
        </div>
        <div
          class="invoiceDetail_content_cen_content"
          v-if="invoiceDetail.type == 1"
        >
          <div class="invoiceDetail_content_cen_content_left">开户行：</div>
          <div class="invoiceDetail_content_cen_content_righ">
            {{ invoiceDetail.bank }}
          </div>
        </div>
        <div
          class="invoiceDetail_content_cen_content"
          v-if="invoiceDetail.type == 1"
        >
          <div class="invoiceDetail_content_cen_content_left">开户帐号：</div>
          <div class="invoiceDetail_content_cen_content_righ">
            {{ invoiceDetail.bankAccount }}
          </div>
        </div>
        <div class="invoiceDetail_content_cen_content">
          <div class="invoiceDetail_content_cen_content_left">开票方：</div>
          <div class="invoiceDetail_content_cen_content_righ">
            {{ invoiceDetail.invoiceName }}
          </div>
        </div>
        <div class="invoiceDetail_content_cen_content">
          <div class="invoiceDetail_content_cen_content_left">申请时间：</div>
          <div class="invoiceDetail_content_cen_content_righ">
            {{ invoiceDetail.createTime }}
          </div>
        </div>
      </div>
      <p class="invoiceDetail_content_title">接收方式</p>
      <div class="invoiceDetail_content_bot">
        <p>
          电子邮箱：<span>{{ invoiceDetail.email }}</span>
        </p>
      </div>
      <div class="button-warp" v-if="invoiceDetail.state == 0">
        <van-button round @click="restSubmit">取消申请</van-button>
      </div>
      <div class="invoiceDetail_content_phone" @click="callBox">
        <img
          class="invoiceDetail_content_phone_left"
          src="../../assets/images/setting/pho.png"
        />
        <div class="invoiceDetail_content_phone_right">客服电话</div>
      </div>
      <div class="invoiceDetail_content_email">邮箱 davecare123@163.com</div>
      <div class="invoiceDetail_content_fix" v-if="invoiceDetail.state == 2">
        <div
          class="invoiceDetail_content_fix_left"
          @click="goEmail"
          :style="{
            background: buttonFlag
              ? 'linear-gradient(180deg, #17E1EB 0%, #24BFFB 100%)'
              : ' #949C9D',
          }"
        >
          发送邮箱
        </div>
        <div
          class="invoiceDetail_content_fix_right"
          @click="download"
          :style="{
            background: buttonFlag
              ? 'linear-gradient(180deg, #17E1EB 0%, #24BFFB 100%)'
              : ' #949C9D',
          }"
        >
          下载文件
        </div>
      </div>
    </div>
    <van-action-sheet v-model="show">
      <div class="content">
        <div class="content_main" @click="call">
          <img src="../../assets/images/setting/ph.png" />
          <p>呼叫 {{ invoiceDetail.phone || "13146233333" }}</p>
        </div>
        <div class="content_cancel" @click="onCancel()">
          <p>取消</p>
        </div>
      </div>
    </van-action-sheet>
    <van-popup v-model="emailBoxShow">
      <div class="popBox">
        <p class="popBox_title">发送邮箱</p>
        <input
          type="text"
          placeholder="请输入电子邮箱"
          @input="changge"
          v-model="message"
        />
        <div
          class="button"
          @click="submitMail"
          :style="{
            background: boxButtonFlag
              ? 'linear-gradient(180deg, #17E1EB 0%, #24BFFB 100%)'
              : '#949C9D',
            opacity: boxButtonFlag ? '1' : '0.49',
          }"
        >
          确定
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Notify } from "vant";
import {
  _sendEmail,
  _invoiceDetail,
  _downInvoice,
  applyCancel,
} from "../../api/setting";
import { ReadStream } from "fs";
export default {
  inject: ["reload"],
  name: "invoiceDetail",
  data() {
    return {
      invoiceDetail: {}, //发票详情数据
      show: false, //打电话弹窗标识
      emailBoxShow: false, //邮箱弹窗标识
      buttonFlag: false, //当前发票是否超过一年标识
      message: "", //邮箱
      loading: false, //loading标识
      invoiceId: "", //发票id
      boxButtonFlag: false, //邮箱确定按钮标识
    };
  },
  created() {
    // this.invoiceDetail = JSON.parse(localStorage.getItem('invoiceDetail'));
    this.invoiceId = this.$route.query.id;
    this.getInvoiceDetail();
  },
  mounted() {},
  methods: {
    //撤销申请
    restSubmit() {
      applyCancel({
        id: this.invoiceId,
      }).then((res) => {
        if (res && res.code == 200) {
          this.loading = false;
          Toast("申请已取消");
          this.reload();
        } else {
          Toast(res.message);
          this.loading = false;
        }
      });
    },
    //获取发票详情
    getInvoiceDetail() {
      this.loading = true;
      _invoiceDetail({
        invoiceId: this.invoiceId,
      })
        .then((res) => {
          if (res && res.code == 200) {
            this.invoiceDetail = res.data;
            this.loading = false;
            if (res.data.createTime) {
              var d = new Date(
                Date.parse(res.data.createTime.replace(/-/g, "/"))
              );
              d.setFullYear(d.getFullYear() + 1);
              var curDate = new Date();
              this.buttonFlag = d < curDate ? false : true;
            }
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //发送邮箱
    sendEmail() {
      this.loading = true;
      _sendEmail({
        invoiceId: this.invoiceId,
        email: this.message,
      })
        .then((res) => {
          if (res && res.code == 200) {
            if (!res.data) {
              Toast("邮箱发送失败，请稍后重试");
            } else {
              Toast("邮箱已发送");
              this.onClickLeft();
            }
            this.emailBoxShow = false;
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //下载文件
    downInvoice() {
      // this.loading = true;
      // _downInvoice({
      //   fileUrl: this.invoiceDetail.pdfUrl,
      //   responseType: 'arraybuffer'
      // })
      //   .then((res) => {
      //   debugger
      //   console.log(res,"文件")
      //   if (res) {
      //     if (!res) {
      //       Toast("文件下载失败");
      //     } else {

      //       // var src='data:image/png;base64,'+ btoa(new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), ''));

      //       // this.srcImg = src; //图片回显
      //       // console.log(this.srcImg,'111111111111')
      //       // var link = document.createElement('a');
      //       // link.href = src;
      //       // link.download = "qrCode.png";
      //       // link.click();
      //       Toast("文件下载成功");
      //     }
      //   } else {
      //     Toast(res.message);
      //     this.loading = false;
      //   }
      // })
      // .catch((err) => {
      //   throw err;
      // })
      // .finally(() => {
      //   this.loading = false;
      // });

      // http://172.16.12.123:31902/psych/files/dif-bucket/2023-05-19/1659375707169492993.png
      // console.log(this.invoiceDetail,"0000000000000000");
      // var url = this.invoiceDetail.pdfUrl;
      // http://172.16.12.123:31902/files/dif-bucket/2023-05-19/1659375707169492993.png
      // var url = 'http://172.16.12.123:31902/psych/files/dif-bucket/2023-05-19/1659375707169492993.png'
      // console.log(url, "图片地址");

      let a = document.createElement("a");
      a.href = this.invoiceDetail.pdfUrl;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    // 点击电话弹窗
    callBox() {
      this.show = true;
    },
    //电话弹窗点击取消
    onCancel() {
      this.show = false;
    },
    //下载文件
    download() {
      if (!this.buttonFlag) {
        Notify({
          message: "该发票开票已超过1年，无法在线申请下载，详询迪夫客服",
          color: "#FFFFFF",
          background: "#FA7D00",
          duration: 3000,
        });
      } else {
        this.downInvoice();
      }
    },
    //点击发送邮箱
    goEmail() {
      if (!this.buttonFlag) {
        Notify({
          message: "该发票开票已超过1年，无法在线申请发送邮箱，详询迪夫客服",
          color: "#FFFFFF",
          background: "#FA7D00",
          duration: 3000,
        });
      } else {
        this.emailBoxShow = true;
      }
    },
    //拨打电话
    call() {
      const a = document.createElement("a");
      let phone = this.invoiceDetail.phone
        ? this.invoiceDetail.phone
        : "13146233333";
      a.href = "tel:" + phone;
      a.click();
      this.show = false;
    },
    //输入邮箱
    changge() {
      var regex =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (regex.test(this.message)) {
        this.boxButtonFlag = true;
      } else {
        this.boxButtonFlag = false;
      }
    },
    //邮箱确定
    submitMail() {
      if (this.boxButtonFlag) {
        this.sendEmail();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.button-warp {
  padding: 0 20px;
  margin-top: 20px;
  width: 100%;
  .van-button {
    width: 100%;
    height: 40px;
    color: #ffffff !important;
    font-size: 16px;
    border: none;
    background: var(--btn-backgruond-color);
  }
}
.invoiceDetail {
  min-height: 100%;
  background: #f5f7fa;
  .invoiceDetail_content {
    padding-top: 48px;
    min-height: 100%;
    padding-bottom: 60px;
    .invoiceDetail_content_title {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #949c9d;
      margin: 8px 0 4px 20px;
    }
    .invoiceDetail_content_top {
      width: 335px;
      background: #ffffff;
      border-radius: 8px;
      padding: 18px 20px 16px 10px;
      margin-left: 20px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      .invoiceDetail_content_top_left {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #626a6b;
      }
      .invoiceDetail_content_top_righ {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
    .invoiceDetail_content_cen {
      width: 335px;
      background: #ffffff;
      border-radius: 8px;
      padding: 1px 20px 20px 10px;
      margin-left: 20px;
      .invoiceDetail_content_cen_content {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
      }
      .invoiceDetail_content_cen_content_left {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #626a6b;
      }
      .invoiceDetail_content_cen_content_righ {
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #626a6b;
        span {
          color: #fa7d00;
          margin-right: 8px;
        }
      }
      .invoiceDetail_content_cen_content_righBold {
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #2e4344;
      }
    }
    .invoiceDetail_content_bot {
      width: 335px;
      background: #ffffff;
      border-radius: 8px;
      padding: 18px 20px 18px 10px;
      margin-left: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #626a6b;
      span {
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2e4344;
      }
    }
    .invoiceDetail_content_phone {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 21px;
      .invoiceDetail_content_phone_left {
        width: 22px;
      }
      .invoiceDetail_content_phone_right {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #20cbf6;
        margin-left: 4px;
      }
    }
    .invoiceDetail_content_email {
      text-align: center;
      margin-top: 5px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #949c9d;
    }
    .invoiceDetail_content_fix {
      width: 100%;
      position: fixed;
      left: 0;
      display: flex;
      justify-content: center;
      bottom: 4px;
      .invoiceDetail_content_fix_left,
      .invoiceDetail_content_fix_right {
        width: 160px;
        height: 40px;
        border-radius: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-right: 15px;
        text-align: center;
        line-height: 40px;
      }
      .invoiceDetail_content_fix_left {
        background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      }
    }
  }
}
::v-deep.van-popup {
  background: none;
}
::v-deep .van-action-sheet__content {
  .content_main {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 345px;
    height: 57px;
    margin-left: 15px;
    background: #fff;
    border-radius: 8px;
    img {
      width: 22px;
      height: 22px;
      margin-right: 4px;
    }
    p {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2e4344;
    }
  }
  .content_cancel {
    width: 345px;
    height: 57px;
    margin-left: 15px;
    background: #fff;
    border-radius: 8px;
    margin-top: 8px;
    margin-bottom: 20px;
    p {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2e4344;
      text-align: center;
      line-height: 57px;
    }
  }
}
.popBox {
  width: 270px;
  padding: 15px 20px;
  background: #ffffff;
  border-radius: 8px;
  .popBox_title {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232323;
    margin-bottom: 4px;
  }
  input {
    width: 227px;
    height: 44px;
    background: #f3f6f7;
    border-radius: 4px;
    padding: 12px 16px;
  }
  .button {
    width: 160px;
    height: 40px;
    background: #949c9d;
    border-radius: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin-top: 12px;
    margin-left: 30.5px;
  }
}
</style>
